import React, { CSSProperties, useRef, useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as PlayButtonSVG } from '../assets/icons/play-btn.svg';

export const VideoFrameWrapperStyled = styled.div`
  height: 580px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;

  position: relative;
  z-index: 10;

  @media (max-width: 820px) {
    height: 360px;
  }
  @media (max-width: 500px) {
    height: 200px;
  }
`;

export const ThumbnailContainerStyled = styled.div<{ $bgImg: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    ${({ $bgImg }) => `url(${$bgImg})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;

  & .play-btn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 165px;
    width: 165px;

    cursor: pointer;

    @media (max-width: 500px) {
      height: 80px;
      width: 80px;
    }
  }
`;

type Props = {
  thumbnailImgURL: string;
  videoEmbededKey?: string;
  style?: CSSProperties;
  className?: string;
  videoPath?: string;
};

const YoutubeVideoEmbed = ({
  thumbnailImgURL,
  videoEmbededKey,
  className,
  style,
  videoPath,
}: Props) => {
  const [playVideo, setPlayVideo] = useState(false);
  const videoPlayerRef = useRef(null);
  return (
    <VideoFrameWrapperStyled style={style} className={className}>
      {!playVideo && (
        <ThumbnailContainerStyled $bgImg={thumbnailImgURL}>
          <PlayButtonSVG
            className="play-btn"
            onClick={() => {
              setPlayVideo(true);
            }}
          />
        </ThumbnailContainerStyled>
      )}
      {playVideo && videoPath ? (
        <video
          src={videoPath}
          height={'100%'}
          width={'100%'}
          controls
          autoPlay={true}
        />
      ) : playVideo && videoEmbededKey ? (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoEmbededKey}?autoplay=1`}
          title="Escape Plan (2013 Movie) Official 4K Trailer - Sylvester Stallone, Arnold Schwarzenegger"
          allow="accelerometer; autoplay; gyroscope; fullscreen;"
          referrerPolicy="strict-origin-when-cross-origin"
          ref={videoPlayerRef}
        ></iframe>
      ) : (
        ''
      )}
    </VideoFrameWrapperStyled>
  );
};

export default YoutubeVideoEmbed;
